import { finalize } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from './../../services/user.service';
import { OfferService } from 'src/app/services/offer.service';
import { GeneralService } from './../../services/general.service';
import { OFFER_TYPE_SWAP } from 'src/app/constants/general.constant';
import { OfferModel, ProductModel } from 'src/app/models/wardrobe.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { OfferSuccessModalComponent } from './../offer-success-modal/offer-success-modal.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-swap-select-item-modal',
  templateUrl: './swap-select-item-modal.component.html',
  styleUrls: ['./swap-select-item-modal.component.scss'],
})
export class SwapSelectItemModalComponent implements OnInit {
  price: number;
  userId: number;
  form: UntypedFormGroup;
  offer: OfferModel;
  @Input() senderId: number;
  @Input() product: ProductModel;
  @Input() actualProductId: ProductModel;

  constructor(
    private userService: UserService,
    private modalCtrl: ModalController,
    private offerService: OfferService,
    private translate: TranslateService,
    private generalService: GeneralService,
    private errorService: ErrorHandlerService,
  ) { }

  ngOnInit() {
    this.userService.get().subscribe(res => {
      this.userId = res.id;
    });
    console.log(this.product);
    this.form = new UntypedFormGroup({
      product_id: new UntypedFormControl(this.actualProductId || null),
      offered_product_id: new UntypedFormControl(this.product?.id || null),
      sent_by: new UntypedFormControl(this.product?.user?.id || null),
      sent_to: new UntypedFormControl(this.senderId || null),
      offer_type: new UntypedFormControl(OFFER_TYPE_SWAP),
      original_price: new UntypedFormControl(this.product?.price || null),
      offered_price: new UntypedFormControl(this.product?.price || null),
      offer_description: new UntypedFormControl(this.product?.description || null)
    });
    this.price = this.product?.price;
  }

  incrementPrice() {
    this.price++;
  }

  decrementPrice() {
    if (this.price > 1) {
      this.price--;
    } else {
      this.errorService.showToast(this.translate.instant(marker('Price.Error')));
    }
  }

  sendOffer() {
    this.form.patchValue({
      sent_by: this.userId
    });
    this.generalService.showLoader();
    this.offerService.createOffer(this.form.value).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.offer = res;
      this.successModal();
    }, error => {
      this.errorService.handle(error);
    });
  }

  async successModal() {
    const modal = await this.modalCtrl.create({
      component: OfferSuccessModalComponent,
      cssClass: 'offer-success-modal',
      canDismiss: true,
      id: 'offerSuccess'
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss(this.offer, null, 'swapSelectItem');
    });
    return await modal.present();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
